import { render, staticRenderFns } from "./namedoc.vue?vue&type=template&id=d1b48488&"
import script from "./namedoc.vue?vue&type=script&lang=js&"
export * from "./namedoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports